const Footer = () => {
  return (
    <article className="footer">
      <section>
        <a
          href="https://github.com/San0077"
          target="_blank"
          rel="noreferrer"
        >
          Designed & Built by Santhosh &copy;2022
        </a>
      </section>
    </article>
  );
};

export default Footer;
